// extracted by mini-css-extract-plugin
module.exports = {"emptyColumn":"EmptyColumn_emptyColumn__3kVNf","addColumn":"EmptyColumn_addColumn__3JBOr"};